import React from "react";
import styled, { css } from "styled-components";

const CorrectorEditor = ({ id, originText, setRevisionArr, revisionArr }) => {
  const correctOnChange = (e) => {
    const newArr = [...revisionArr];
    newArr[id].correction = e.target.value;
    setRevisionArr(newArr);
  }; //revisionArr에 첨삭자가 수정한 수정본 데이터 업데이트

  const commentOnChange = (e) => {
    const newArr = [...revisionArr];
    newArr[id].comment = e.target.value;
    setRevisionArr(newArr);
  }; //revisionArr에 첨삭자가 추가한 comment 데이터 업데이트

  return (
    <Container>
      <QuestionSection>
        <div>Q{id + 1}.</div>
        <div>{revisionArr[id].question}</div>
      </QuestionSection>
      <QuestionLine />
      <ContentsSection>
        <OriginWrap>
          <TextTitleTap>원본</TextTitleTap>
          <div className="textBox">
            <textarea value={originText} name={id} readOnly={true} />
            <div className="textareaInfo">
              공백포함: 총 0자 ( 0byte ) | 공백제외 : 총 0자 ( 0byte )
            </div>
          </div>
        </OriginWrap>
        <RevisionWrap>
          <TextTitleTap>수정본</TextTitleTap>
          <div className="textBox">
            <textarea
              value={revisionArr[id].correction}
              onChange={correctOnChange}
            />
            <div className="textareaInfo">
              공백포함: 총 0자 ( 0byte ) | 공백제외 : 총 0자 ( 0byte )
            </div>
          </div>
        </RevisionWrap>
      </ContentsSection>
      <CommentSection>
        <div className="commentTitleWrap">
          <TextTitleTap>코멘트</TextTitleTap>
          <div className="commentBar" />
        </div>
        <div className="commentTextBox">
          <textarea
            placeholder="코멘트를 남겨주세요."
            value={revisionArr[id].comment}
            onChange={commentOnChange}
          ></textarea>
        </div>
      </CommentSection>
    </Container>
  );
};

export default CorrectorEditor;

const FlexCenter = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Themecolor = css`
  color: #7903d4;
`;

const Container = styled.section`
  width: 1200px;
  margin: 0px auto;
`;
const QuestionSection = styled.div`
  ${FlexCenter}
  justify-content: start;
  padding: 0px 30px;
  margin-top: 100px;

  & > div:nth-child(1) {
    ${Themecolor}
    font-size: 50px;
    font-weight: bold;
    font-style: italic;
    text-align: center;
  }
  & > div:nth-child(2) {
    margin-left: 13px;
    font-size: 17px;
    line-height: 1.5;
    color: #676767;
  }
`;
const QuestionLine = styled.div`
  width: 100%;
  height: 1px;
  margin-top: 30px;
  background-color: #b3b3b3;
`;
const ContentsSection = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 70px;
  margin-bottom: 70px;
`;

const OriginWrap = styled.div`
  .textTitle {
    ${Themecolor}
    width: 72px;
    height: 25px;
    margin-bottom: 20px;
    object-fit: contain;
    color: white;
  }
  .textBox {
    width: 540px;
    height: 688px;
    border: solid 1px #666666;
    textarea {
      width: 100%;
      height: 95%;
      border: 0px;
      padding: 48px 36px 76px 29px;
      font-size: 14px;
      resize: none;
      outline-style: none;
    }
  }

  .textareaInfo {
    ${FlexCenter}
    justify-content: flex-end;
    width: 100%;
    padding-right: 30px;
    font-size: 13px;
    color: #363636;
  }
`;

const RevisionWrap = styled(OriginWrap)``;

const CommentSection = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  .commentTitleWrap {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 25px;
    .commentBar {
      width: 1068px;
      height: 2px;
      margin-bottom: 20px;
      background-color: #7903d4;
    }
  }
  .commentTextBox {
    display: flex;
    justify-content: center;

    textarea {
      width: 1139px;
      height: 129px;
      padding: 31px 23px 46px 19px;
      border: solid 1px #b3b3b3;
      resize: none;
    }
  }
`;

const TextTitleTap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 25px;
  margin-bottom: 20px;
  background-color: #7903d4;
  color: white;
`;
